import { useEffect, useState } from 'react'
import { requestClipboardRestore, requestExtensionRedeem } from '../lib/clipboardCheckout'

export function ClipboardRestore() {
  const [email, setEmail] = useState('')
  const [sessionId, setSessionId] = useState('')
  const [message, setMessage] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    document.title = 'JOT Clipboard — Restore purchase'
  }, [])

  async function sendLink(event: React.FormEvent) {
    event.preventDefault()
    setError(null)
    setMessage(null)
    setBusy(true)
    try {
      const result = await requestClipboardRestore(email)
      setMessage(
        result.emailed
          ? 'If that email bought Clipboard, a one-time restore link is on its way.'
          : 'If that email bought Clipboard, we recorded a restore request. Open your original confirmation page, or paste the session id from that URL below.'
      )
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not start restore')
    } finally {
      setBusy(false)
    }
  }

  function redeemSession(event: React.FormEvent) {
    event.preventDefault()
    const id = sessionId.trim()
    if (!id.startsWith('cs_')) {
      setError('That does not look like a Stripe session id (it starts with cs_).')
      return
    }
    setError(null)
    requestExtensionRedeem({ sessionId: id })
    setMessage('Asked the extension to unlock this computer. Open the toolbar popup to confirm.')
  }

  return (
    <div className="lp lp--extension">
      <nav className="lp-nav">
        <div className="lp-nav-inner">
          <a href="/home" className="lp-wordmark">JOT</a>
          <div className="lp-nav-center">
            <a href="/subscribe" className="lp-nav-link">Unlock</a>
          </div>
        </div>
      </nav>
      <section className="lp-hero">
        <div className="lp-hero-inner clip-buy">
          <p className="lp-hero-eyebrow">Restore purchase</p>
          <h1 className="lp-hero-headline">Move full history to this Chrome.</h1>
          <p className="lp-hero-body">
            This replaces the old install. The previous computer goes back to
            seven days on the next check.
          </p>

          <form className="clip-buy-form" onSubmit={sendLink}>
            <label>
              Email used at checkout
              <input
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
                autoComplete="email"
              />
            </label>
            <button type="submit" className="lp-cta-primary" disabled={busy}>
              {busy ? 'Sending…' : 'Email a restore link'}
            </button>
          </form>

          <form className="clip-buy-form" onSubmit={redeemSession}>
            <label>
              Or paste the session id from your confirmation URL
              <input
                type="text"
                value={sessionId}
                onChange={(event) => setSessionId(event.target.value)}
                placeholder="cs_…"
                autoComplete="off"
                spellCheck={false}
              />
            </label>
            <button type="submit" className="lp-cta-primary">Unlock this computer</button>
          </form>

          {message && <p className="lp-hero-proof">{message}</p>}
          {error && <p className="clip-buy-error">{error}</p>}
        </div>
      </section>
    </div>
  )
}
